WiseMetering.Model.Device = WiseMetering.Model.extend({

    urlRoot: '/devices',

    history: function() {
        return this.sync.call(this, null, this, { url: this.url() + '/history' });
    }

});
